module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-3-8ccc2df4df514123cb3476ee948b042a.jpg";